import React from 'react';
import { Link } from '@mui/material';
import { FinalAllocation } from './AllocationFinalMessage.props';

interface ListAllocationsProps {
  finalAllocations: FinalAllocation[];
  handleClick: (dateSlug: string, versionSlug: string) => void;
}

const ListAllocations = ({ finalAllocations, handleClick }: ListAllocationsProps) => {
  if (finalAllocations.length > 0) {
    return (
      <ul>
        {finalAllocations.map(alloc => (
          <li key={alloc.slug}>
            <Link
              component="button"
              variant="body2"
              underline="none"
              onClick={() => handleClick(alloc.company_measurement_date?.measurement_date?.slug, alloc.slug)}>
              {`See Allocation ${alloc.name}`}
            </Link>
          </li>
        ))}
      </ul>
    );
  }
  return null;
};

export default ListAllocations;
